export enum IndicatorStatus {
  Saving = 'saving',
  Saved = 'saved',
  Idle = 'idle',
  Error = 'error',
}
